module.exports = __webpack_public_path__ + "static/media/live_court_left.84ba11de.jpg";